var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"con-head"},[_vm._m(0),_c('div',{staticClass:"con-btn",on:{"click":function($event){return _vm.schoolApply()}}},[_vm._v("高校申请试用")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"height":"100%","position":"absolute"},attrs:{"src":require("../assets/head-logo.png")}})])
}]

export { render, staticRenderFns }